import React from "react";
import { Link, Redirect, useParams } from "react-router-dom";
import {
  FaCheckCircle,
  FaPrint,
  FaUserPlus,
  FaUsers,
  FaFileAlt,
  FaCopy,
} from "react-icons/fa";
import SessionManager from "../Utils/SessionManager";
import BackButton from "../ChildComponent/BackButton";
import COLORS from "../resources/colors/COLORS";
import myToast from "../Utils/MyToast";
import "../css/Admin_css/admin-customize.css";
import "../css/Admin_css/payroll.css";

const HERO_GRADIENT = `linear-gradient(135deg, ${COLORS.primary_color_shade5} 0%, ${COLORS.primary_color_shade7} 55%, ${COLORS.primary_color_shade9} 100%)`;

const PAGE_FONT =
  'Inter, system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif';

//Created By Cursor
function decodeParam(value) {
  if (value == null || value === "") return "";
  try {
    return decodeURIComponent(String(value));
  } catch {
    return String(value);
  }
}

//Created By Cursor
function StRegSuccessfull() {
  const loggedIn = localStorage.getItem("token") != null;
  const params = useParams();
  const enrollmentNo = decodeParam(params.Enrollment_no);
  const sessionId = decodeParam(params.session_id);

  //Created By Cursor
  const copyEnrollment = () => {
    if (!enrollmentNo) return;
    if (navigator?.clipboard?.writeText) {
      navigator.clipboard
        .writeText(enrollmentNo)
        .then(() => myToast.notify_success("Enrollment number copied."))
        .catch(() => myToast.notify_warning("Could not copy enrollment number."));
      return;
    }
    myToast.notify_warning("Clipboard not available.");
  };

  if (!loggedIn) return <Redirect to="/Login" />;

  return (
    <div
      className="content payroll-page sm-page sr-page srs-page"
      style={{ background: COLORS.white, fontFamily: PAGE_FONT }}
    >
      <div
        className="content-header"
        style={{ background: COLORS.primary_color_shade5 }}
      >
        <div className="leftside-content-header">
          <ul className="breadcrumbs">
            <li>
              <i
                className="fa fa-home"
                aria-hidden="true"
                style={{ color: COLORS.white }}
              />
              <span style={{ color: COLORS.white }}>
                {" "}
                Registration Successful
              </span>
            </li>
          </ul>
        </div>
        <div className="rightside-content-header">
          <BackButton />
        </div>
      </div>

      <div className="bg_page_white_rounded box_shadow animated fadeInUp sm-shell">
        <header className="sm-hero" style={{ "--sm-hero-bg": HERO_GRADIENT }}>
          <div className="sm-hero__brand">
            <div className="sm-hero__icon srs-hero-icon" aria-hidden>
              <FaCheckCircle />
            </div>
            <div className="min-w-0">
              <h1 className="sm-hero__title">Student Registered</h1>
              <p className="sm-hero__sub">
                Admission is saved. Print acknowledgement or admission form,
                or register another student.
              </p>
            </div>
          </div>
        </header>

        <div className="sr-body srs-body">
          <section className="srs-enroll" aria-label="Enrollment number">
            <div className="srs-enroll__check" aria-hidden>
              <FaCheckCircle />
            </div>
            <div className="srs-enroll__meta min-w-0">
              <span className="srs-enroll__label">Enrollment number</span>
              <strong className="srs-enroll__value">{enrollmentNo || "—"}</strong>
              {sessionId ? (
                <span className="srs-enroll__session">
                  Session ID · {sessionId}
                </span>
              ) : null}
            </div>
            {enrollmentNo ? (
              <button
                type="button"
                className="srs-copy-btn"
                onClick={copyEnrollment}
                title="Copy enrollment number"
              >
                <FaCopy aria-hidden /> Copy
              </button>
            ) : null}
          </section>

          <section className="srs-next" aria-label="Next steps">
            <h2 className="srs-next__title">What’s next</h2>
            <div className="srs-actions">
              <Link
                to={`/AdminMain/Acknowledgement/${encodeURIComponent(
                  enrollmentNo
                )}/${encodeURIComponent(sessionId)}`}
                className="srs-action srs-action--primary"
              >
                <span className="srs-action__icon" aria-hidden>
                  <FaPrint />
                </span>
                <span className="srs-action__text">
                  <strong>Print acknowledgement</strong>
                  <span>Admission letter for parents</span>
                </span>
              </Link>

              <Link
                to="/AdminMain/StudentRegistration"
                className="srs-action"
              >
                <span className="srs-action__icon" aria-hidden>
                  <FaUserPlus />
                </span>
                <span className="srs-action__text">
                  <strong>Another registration</strong>
                  <span>Admit the next student</span>
                </span>
              </Link>

              <Link
                to={`/AdminMain/AdmissionForm/${encodeURIComponent(
                  enrollmentNo
                )}/${encodeURIComponent(sessionId)}`}
                className="srs-action"
              >
                <span className="srs-action__icon" aria-hidden>
                  <FaFileAlt />
                </span>
                <span className="srs-action__text">
                  <strong>Print admission form</strong>
                  <span>Preview for this student</span>
                </span>
              </Link>

              <Link to="/AdminMain/StudentManagement" className="srs-action">
                <span className="srs-action__icon" aria-hidden>
                  <FaUsers />
                </span>
                <span className="srs-action__text">
                  <strong>Student list</strong>
                  <span>Back to student management</span>
                </span>
              </Link>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
}

export default StRegSuccessfull;
